import React from 'react';

import { Spinner } from '../../spinner/spinner';

export interface DefaultGhostButtonProps {
    text: React.ReactNode;
    onClick: () => void;
    disabled?: boolean;
    isLoading?: boolean;
    dataTestId?: string;
}

export const DefaultGhostButton = (props: DefaultGhostButtonProps) => {
    return (
        <button
            disabled={props.disabled || props.isLoading}
            onClick={props.onClick}
            data-testid={props.dataTestId ?? 'ghost-button'}
            className='hover:bg-brand-light text-brand-primary disabled:text-brand-muted disabled:hover:text-brand-muted hover:text-brand-secondary inline-flex cursor-pointer items-center justify-center gap-2.5 rounded-md px-4 py-3 disabled:cursor-not-allowed disabled:hover:bg-inherit'>
            <div className='flex content-center items-center justify-center gap-2 text-base font-medium'>
                {props.isLoading && <Spinner className='text-border-default fill-brand-primary size-4' />}
                {props.text}
            </div>
        </button>
    );
};
